import React, { useState } from 'react';
import axios from 'axios';
import { servicios_grupogack_nomina, cambios_no_guardados } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import { JsonPensiones } from '../../../Helpers/JsonToOneLevel';
import ModalService from '../../../ModalService/ModalService';
import AlertForm from '../../../../../../Services/AlertForm';
import FormularioPensiones from './FormularioPensiones';

const ModalEditPensiones = ({ openEdit, setOpenEdit, elementSelect, editar, errorTable, informacionAdicional, nombreModulo }) => {
    const [ error, setError ] = useState( null );
    const cerrarModal = () => {
        setOpenEdit( false );
        setError( null );
    }

    const actualizarPension = ( pension ) => {
        axios.put( `${servicios_grupogack_nomina}s/pensiones/`, pension, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        editar( JsonPensiones(respuesta.data.dataResponse) );
                        setOpenEdit( false );
                        break;
                    case 400:
                    case 404:
                        setError( <AlertForm message={ respuesta.data.msg } /> );
                        break;
                    default:
                        errorTable( cambios_no_guardados );
                        break;
                }
            })
            .catch( error => {
                errorTable( cambios_no_guardados );
            })
    }

    return (
        <ModalService title="Actualizar Pensión" parentNode={nombreModulo} minWidth="40%"
            isOpen={ openEdit } onClose={ () => cerrarModal() } >
                <FormularioPensiones
                    error={error}
                    elementSelect={elementSelect}
                    informacion={informacionAdicional}
                    actualizarPension={actualizarPension}
                />
        </ModalService>
    );
};

export default ModalEditPensiones;